import React from 'react';
import './DelayAlertModal.css';

interface DelayAlertModalProps {
    isOpen: boolean;
    onClose: () => void;
}

const DelayAlertModal: React.FC<DelayAlertModalProps> = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div className="delay-alert-overlay" onClick={handleBackdropClick}>
            <div className="delay-alert-modal">
                <button className="delay-alert-close" onClick={onClose} aria-label="Close">
                    ×
                </button>

                <div className="delay-alert-icon">
                    ⏰
                </div>

                <h2 className="delay-alert-title">
                    We're experiencing high demand right now — thank you for keeping us busy!
                </h2>

                <p className="delay-alert-message">
                    We're still accepting orders as normal, though deliveries might take a little longer.
                </p>

                <p className="delay-alert-footer">
                    We truly appreciate your patience — your meal is being cooked fresh, with care and love. ❤️
                </p>

                <button className="delay-alert-button" onClick={onClose}>
                    Got it!
                </button>
            </div>
        </div>
    );
};

export default DelayAlertModal;
